import {
  ICianApiSiteV1SearchRegionsCitiesRequest,
  ICianApiSiteV1SearchRegionsCitiesResponse,
  ICianApiSiteV1SearchRegionsCitiesResponse200,
  ICianApiSiteV1SearchRegionsCitiesResponse400,
  createCianApiSiteV1SearchRegionsCitiesModel,
  fetchCianApiSiteV1SearchRegionsCities,
} from 'shared/repositories/monolith-python/cian-api/site/v1/search-regions-cities';
import { FetchAssertsService } from 'shared/services/FetchAssertsService';
import { IApplicationContext } from 'shared/types/applicationContext';

export function fetchSearchRegionsCitiesService(
  dependencies: IApplicationContext,
  parameters: ICianApiSiteV1SearchRegionsCitiesRequest,
): Promise<ICianApiSiteV1SearchRegionsCitiesResponse> {
  const {
    httpApi,
    custom: { subdomain },
    logger,
  } = dependencies;

  const fetchAssertsService = new FetchAssertsService(
    createCianApiSiteV1SearchRegionsCitiesModel(parameters),
    'src/shared/store/serverSide/monolith-python/cian-api/site/v1/search-regions-cities/internal/fetchService.ts',
    logger,
  );

  return fetchCianApiSiteV1SearchRegionsCities<
    ICianApiSiteV1SearchRegionsCitiesResponse200,
    ICianApiSiteV1SearchRegionsCitiesResponse400
  >({
    config: { subdomain },
    httpApi,
    parameters,
  }).then(
    result => {
      const statusCode = result.statusCode;

      switch (result.statusCode) {
        case 200:
          return result.response;
        case 400:
          throw fetchAssertsService.assert400StatusCodeError({ response: result.response.data });
        default:
          throw fetchAssertsService.assertUnknownStatusCodeError(statusCode);
      }
    },
    error => {
      throw fetchAssertsService.assertUnknownServerError(error);
    },
  );
}
